import { createContext } from "react";

type MusicPlayOptions = {
  src: string;
  volume?: number;
  autoPlay?: boolean;
  loop?: boolean;
};

type MusicContextValue = {
  isMuted: boolean;
  isReady: boolean;
  currentSrc: string | null;
  volume: number;
  play: (options: MusicPlayOptions) => void;
  stop: () => void;
  mute: () => void;
  unmute: () => void;
  toggleMute: () => void;
  setVolume: (value: number) => void;
};

const MusicContext = createContext<MusicContextValue | undefined>(undefined);

export { MusicContext };
export type { MusicContextValue, MusicPlayOptions };
